import * as React from 'react';
export default () => (
  <svg
    className="DocsPage-breadcrumbSeparator"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 32"
  >
    <path d="M3 3 L15 16 L3 29" />
  </svg>
);
